import { React, useEffect, useState } from "react";
import ScmModuleStyle from '../styles/scm.module.css';
import warning from '../assets/warning.png';


const CompletedCancelledOrders = ({ simObj, setSimObj, setError }) => {
  const noOfRatings = [1, 2, 3, 4, 5];
  const [isToggledDeliveryPopup, setIsToggledDeliveryPopup] = useState(false);
  const starRating = 2;
  const onMouseOverHandler = (event) => {
    let left = event.currentTarget.offsetLeft + 23;
    let top = (event.currentTarget.offsetTop - (window.$(event.currentTarget.nextSibling).outerHeight() / 2) );
    window.$(event.currentTarget.nextSibling).removeAttr("style")
    window.$(event.currentTarget.nextSibling).removeClass("bottom");
    window.$(event.currentTarget.nextSibling).addClass("top left");
    window.$(event.currentTarget.nextSibling).css("left", left);
    window.$(event.currentTarget.nextSibling).css("top", top);
  }
    /*Delivery date tooltip*/ 
  const handleToggleDeliveryPopup = (event) => {
      if(event === undefined){
      return;
      }
      setIsToggledDeliveryPopup(!isToggledDeliveryPopup);
  };
  
  const handleKeyDownDeliveryPopup = (event) => {
      // Toggle the button when Enter or Space is pressed
      if (event.key === 'Enter' || event.key === ' ') {
      handleToggleDeliveryPopup();
      }
  };
  window.$(document).on("click", function(e){
      if(!window.$(e.target).closest('#deliveryDatePopup').length > 0){
      setIsToggledDeliveryPopup(false);
      }
  });
  useEffect(() => {
    window.$('.completedcancelorder .supplier_details:not([initialize="true"])').attr("initialize",true).off('click').popup({
      inline: true,
      hoverable: false,
      lastResort: 'bottom right',
      on: 'click',
      onShow: function () {
        window.$('.ui.popup').css('max-height', window.$(window).height());
      },
      //   boundary: `.scm_place-order-container__VVRLh`
    });
  }, [simObj?.supplierDetails,[]])
  return (
    <div className={`${ScmModuleStyle["bids-from-supplier"]} ${ScmModuleStyle["cancel-order-tbl"]}`}>
      {
        (simObj?.actions?.options?.viewOrderDetails?.filter((viewOrderDetail) => viewOrderDetail.orderStatus != "INPROGRESS")?.length > 0) ?
          (<>
            <div className={`${ScmModuleStyle["place-order-container"]}`}>
              <table className={`ui celled table unstackable completedcancelorder ${ScmModuleStyle["ui"]} ${ScmModuleStyle["celled"]} ${ScmModuleStyle["table"]} ${ScmModuleStyle["unstackable"]} ${ScmModuleStyle["completed-order-table"]} `} border="0" cellpadding="5" cellspacing="5">
                <thead>
                  <tr>
                    <th scope="col" colspan="2">Supplier Name</th>
                    <th scope="col" colspan="2">Cost Per Unit </th>
                    <th scope="col">Weekly Delivery / Rush Delivery</th>
                    <th scope="col" style={{ "width": "70px" }}>Order Quantity</th> 
                    <th scope="col">Rush Delivery</th>
                    <th scope="col" style={{"width":"90px"}}>Order Cost</th>
                    <th scope="col" style={{ "width": "90px" }} className={`${ScmModuleStyle['delivery-header']}`}>
                      <div className={`${ScmModuleStyle["anchor-wrapper"]}`}>
                        <span>Delivery Date</span>
                        {/* <a data-tooltip="Keep an eye on the delivery date! Dates displayed in red will not finish until after your deadline." data-position="bottom center"><img src={warning} /></a> */}
                        <a id="deliveryDatePopup" className={`${ScmModuleStyle["deliveryAnchor"]}`} href="javascript:void(0)" role="button" tabIndex={0} aria-label="Info about delivery date" onClick={handleToggleDeliveryPopup} 
                            onKeyDown={handleKeyDownDeliveryPopup}
                            onMouseEnter={()=> {
                            if(window.innerWidth > 991) {
                                setIsToggledDeliveryPopup(true);
                            }
                            }}
                            onMouseLeave={()=> {
                            if(window.innerWidth > 991) {
                                setIsToggledDeliveryPopup(false);
                            }
                            }}
                            onBlur={()=> setIsToggledDeliveryPopup(false)}><img src={warning} alt="" /></a>
                      </div>
                      <div className={`ui fluid popup bottom center transition ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup} ${ScmModuleStyle["delivery-date-popup"]}`} style={{ display: isToggledDeliveryPopup == true ? "block" : "none" }}>
                          <p role="alert" aria-live="assertive">Keep an eye on the delivery date! Dates displayed in red will not finish until after your deadline.</p>
                      </div>
                    </th>
                    <th scope="col" style={{"width":"90px"}}>Delivery Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className={`${ScmModuleStyle["internal-header"]}`}>
                    <td scope="row" colspan="10"><strong>SKU 1</strong></td>
                  </tr>
                  {
                    simObj?.actions?.options?.viewOrderDetails?.filter((viewOrderDetail) => viewOrderDetail.orderStatus != "INPROGRESS")?.map((supplier, index) => (
                      simObj?.supplierDetails[supplier.supplierId]?.supplierComp1Available ? (<tr>
                        <td scope="row" className={`${ScmModuleStyle["supplier-name"]}`} colspan="2" key={index}>
                          <span>{supplier?.supplierName}</span>
                          <a href="javascript:void(0)" onClick={onMouseOverHandler} className={`ui supplier_details ${ScmModuleStyle.ui} ${ScmModuleStyle.supplier_details}`}>
                            <img src={warning} alt="supplier info popup" />
                          </a>
                          <div className={`ui fluid popup top left transition hidden ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup}`} role="alert" aria-live="assertive">
                            <div className="ui column divided center aligned grid">
                              <div className={`column ${ScmModuleStyle["imgtxt"]}`}>
                                <img src={`${require(`../assets/suppliers/${supplier?.supplierId}.png`)}`} alt={supplier?.supplierId} style={{ width: '60px' }} />
                                <p style={{ 'margin-top': '0px' }}>{simObj?.supplierDetails[supplier.supplierId]?.supplierPromotion}</p></div>
                            </div>
                            <div className="ui column divided center aligned grid">
                              <div className={`column ${ScmModuleStyle["rating"]}`}>
                                <div className={`${ScmModuleStyle["quality-star-rating"]}`}>
                                  <span>Quality Rating</span>
                                </div>
                                <ul className={`${ScmModuleStyle["rating-list"]}`}>
                                  {noOfRatings.map((number, index) =>
                                    number <= simObj?.supplierDetails[supplier.supplierId]?.starRating ? (
                                      <li key={number}>
                                        <span className={`fa fa-star checked ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star"]}`} />
                                      </li>
                                    ) : Number(simObj?.supplierDetails[supplier.supplierId]?.starRating) === simObj?.supplierDetails[supplier.supplierId]?.starRating &&
                                      simObj?.supplierDetails[supplier.supplierId]?.starRating % 1 !== 0 &&
                                      number <= Math.round(simObj?.supplierDetails[supplier.supplierId]?.starRating) ? (
                                      <li key={number}>
                                        <span className={`fa fa-star-half-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-half-o"]}`} />
                                      </li>
                                    ) : (
                                      <li key={number}>
                                        <span className={`fa fa-star-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-o"]}`} />
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td colspan="2">
                          <ul className={`${ScmModuleStyle["pqd"]}`}>
                            {
                              supplier?.priceQuantityDetailList?.map((pqd, index) => (
                                <li key={index}>
                                  <span >{pqd?.minNumberofUnits} - {pqd?.maxNumberofUnits}</span>
                                  <span> ${pqd?.costPerUnit} </span>
                                </li>
                              ))
                            }
                          </ul>
                        </td>
                        <td className={`${ScmModuleStyle["mod-value"]}`}>{simObj?.supplierDetails[supplier.supplierId]?.supplierUnitsPerWeek}&nbsp;/&nbsp;{simObj?.supplierDetails[supplier.supplierId]?.supplierExpediteUnitsPerWeek}</td>
                        <td>
                          <span>{supplier?.component1Unit}</span>
                        </td>
                        <td>
                          <input type='checkbox' checked={supplier?.rushOptionTaken} disabled={!supplier?.rushOptionAvailable} />
                        </td>
                        <td>{supplier?.totalCost != undefined ? "$" + Math.floor(supplier?.totalCost) : ''}</td>
                        <td>{supplier?.deliveryDate != undefined && supplier?.deliveryDate != "" ? new Date(supplier?.deliveryDate).toLocaleDateString() : ''}</td>
                        <td>
                          {supplier?.orderStatus === "COMPLETE" && (
                            <span style={{ "color": "#008638" }}><strong>Completed</strong></span>
                          )}
                          {supplier?.orderStatus === "CANCELLED" && (
                            <span style={{ "color": "#DB0020" }}><strong>Cancelled</strong></span>
                          )}
                        </td>

                      </tr>) : ''
                    ))

                  }
                  <tr className={`${ScmModuleStyle["internal-header"]}`}>
                    <td scope="row" colspan="10"><strong>SKU 2</strong></td>
                  </tr>
                  {
                    simObj?.actions?.options?.viewOrderDetails?.filter((viewOrderDetail) => viewOrderDetail.orderStatus != "INPROGRESS")?.map((supplier, index) => (
                      simObj?.supplierDetails[supplier.supplierId]?.supplierComp2Available ? (<tr>
                        <td scope="row" className={`${ScmModuleStyle["supplier-name"]}`} colspan="2" key={index}>
                          <span>{supplier?.supplierName}</span>
                          <a href="javascript:void(0)" onClick={onMouseOverHandler} className={`ui supplier_details ${ScmModuleStyle.ui} ${ScmModuleStyle.supplier_details}`}>
                            <img src={warning} alt="supplier info popup" />
                          </a>
                          <div className={`ui fluid popup top left transition hidden ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup}`} role="alert" aria-live="assertive">
                            <div className="ui column divided center aligned grid">
                              <div className={`column ${ScmModuleStyle["imgtxt"]}`}>
                                <img src={`${require(`../assets/suppliers/${supplier?.supplierId}.png`)}`} alt={supplier?.supplierId} style={{ width: '60px' }} />
                                <p style={{ 'margin-top': '0px' }}>{simObj?.supplierDetails[supplier.supplierId]?.supplierPromotion}</p></div>
                            </div>
                            <div className="ui column divided center aligned grid">
                              <div className={`column ${ScmModuleStyle["rating"]}`}>
                                <div className={`${ScmModuleStyle["quality-star-rating"]}`}>
                                  <span>Quality Rating</span>
                                </div>
                                <ul className={`${ScmModuleStyle["rating-list"]}`}>
                                  {noOfRatings.map((number, index) =>
                                    number <= simObj?.supplierDetails[supplier.supplierId]?.starRating ? (
                                      <li key={number}>
                                        <span className={`fa fa-star checked ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star"]}`} />
                                      </li>
                                    ) : Number(simObj?.supplierDetails[supplier.supplierId]?.starRating) === simObj?.supplierDetails[supplier.supplierId]?.starRating &&
                                      simObj?.supplierDetails[supplier.supplierId]?.starRating % 1 !== 0 &&
                                      number <= Math.round(simObj?.supplierDetails[supplier.supplierId]?.starRating) ? (
                                      <li key={number}>
                                        <span className={`fa fa-star-half-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-half-o"]}`} />
                                      </li>
                                    ) : (
                                      <li key={number}>
                                        <span className={`fa fa-star-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-o"]}`} />
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td colspan="2">
                          <ul className={`${ScmModuleStyle["pqd"]}`}>
                            {
                              supplier?.priceQuantityDetailList?.map((pqd, index) => (
                                <li key={index}>
                                  <span >{pqd?.minNumberofUnits} - {pqd?.maxNumberofUnits}</span>
                                  <span> ${pqd?.costPerUnit} </span>
                                </li>
                              ))
                            }
                          </ul>
                        </td>
                        <td className={`${ScmModuleStyle["mod-value"]}`}>{simObj?.supplierDetails[supplier.supplierId]?.supplierUnitsPerWeek}&nbsp;/&nbsp;{simObj?.supplierDetails[supplier.supplierId]?.supplierExpediteUnitsPerWeek}</td>
                        <td>
                          <span>{supplier?.component2Unit}</span>
                        </td>
                        <td><input type='checkbox' checked={supplier?.rushOptionTaken} disabled={!supplier?.rushOptionAvailable} /></td>
                        <td>{supplier?.totalCost != undefined ? "$" + Math.floor(supplier?.totalCost) : ''}</td>
                        <td>{supplier?.deliveryDate != undefined && supplier?.deliveryDate != "" ? new Date(supplier?.deliveryDate).toLocaleDateString() : ''}</td>
                        <td>
                          {supplier?.orderStatus === "COMPLETE" && (
                            <span style={{ "color": "#008638" }}><strong>Completed</strong></span>
                          )}
                          {supplier?.orderStatus === "CANCELLED" && (
                            <span style={{ "color": "#DB0020" }}><strong>Cancelled</strong></span>
                          )}
                        </td>
                      </tr>) : ''
                    ))

                  }
                </tbody>
              </table>

            </div>
          </>)
          :
          (<>
            <div className="nobids-received" style={{ "margin": "20px 10px" }}>
              <p> Please place orders.</p>
            </div>
          </>)
      }
    </div>
  )
}

export default CompletedCancelledOrders
